import { Container, Button, Modal, Form } from "react-bootstrap";
import { useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import VideocamIcon from "@mui/icons-material/Videocam";
import PersonalImage from "../../../../../helpers/fileUpload";
import ClearIcon from "@mui/icons-material/Clear";
import Card from "react-bootstrap/Card";
const Statusmodal = ({ show, handleClose }) => {
  const [uploadedImages, setUploadedImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const inputfile = useRef(null);
  const upload_img = () => {
    inputfile.current.click();
  };

  const onChangePicture = (e) => {
    if (e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
    }
    if (e.target.files[0]) {
      setSelectedImage(e.target.files[0]);
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
    }
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setUploadedImages([...uploadedImages, reader.result]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
  };

  const removeImage = (index) => {
    const updatedImages = [...uploadedImages];
    updatedImages.splice(index, 1);
    setUploadedImages(updatedImages);
  };

  return (
    <>
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Container>
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton className="font-sm">
            <Modal.Title>
              <h6 className="m-0">Add Status</h6>
            </Modal.Title>
          </Modal.Header>
          <Form.Select
            aria-label="Default select example"
            className="w-25 ms-3 mt-3"
          >
            <option>Privacy</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </Form.Select>
          <Modal.Body>
            <div className="form-group">
              <textarea
                className="form-control"
                rows="3"
                placeholder=" Write something...."
              ></textarea>
            </div>
            <div className="d-flex justify-content-end">
              <span role="button">
                <span role="button">
                  <div onClick={upload_img} className="text-warning me-2">
                    <CameraAltIcon />
                    <input
                      type="file"
                      id="file"
                      ref={inputfile}
                      style={{ display: "none" }}
                      name="image"
                      onChange={(e) => {
                        onChangePicture(e);
                      }}
                    />
                  </div>
                </span>
              </span>

              <div onClick={""} className="text-success">
                <VideocamIcon />
                <input id="file" style={{ display: "none" }} />
              </div>
            </div>
            {/* <Col lg={8} className=" mt-1 d-flex justify-content-start "> */}
            <div>
              {uploadedImages.map((image, index) => (
                <Card
                  style={{
                    width: "6rem",
                    height: "6rem",
                    border: "2px solid",
                  }}
                  key={index}
                >
                  <Card.Img
                    className="imet-fit upload-img"
                    src={image}
                    alt={`Uploaded ${index}`}
                  />
                  <div
                    className="close-btnone"
                    onClick={() => removeImage(index)}
                  >
                    <ClearIcon />
                  </div>
                </Card>
              ))}
            </div>

            {/* </Col> */}
          </Modal.Body>
          <Modal.Footer className="justify-content-between">
            <Button onClick={handleClose} className="cancle-btn">
              Cancle
            </Button>
            <Button className="post-btn " onClick={handleClose}>
              Post
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default Statusmodal;
